export const kn = {
  // Navigation (Kannada)
  explore: 'ಅನ್ವೇಷಿಸು',
  search: 'ಹುಡುಕು',
  create: 'ಪೋಸ್ಟ್ ರಚಿಸಿ',
  messages: 'ಸಂದೇಶಗಳು',
  notifications: 'ಅಧಿಸೂಚನೆಗಳು',
  settings: 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
  profile: 'ಪ್ರೊಫೈಲ್',
  logout: 'ಲಾಗ್ ಔಟ್',
  home: 'ಮುಖಪುಟ',
  
  // Authentication
  signin: 'ಸೈನ್ ಇನ್',
  signup: 'ಸೈನ್ ಅಪ್',
  login: 'ಲಾಗಿನ್',
  register: 'ನೋಂದಣಿ',
  email: 'ಇಮೇಲ್',
  password: 'ಪಾಸ್‌ವರ್ಡ್',
  confirmPassword: 'ಪಾಸ್‌ವರ್ಡ್ ದೃಢೀಕರಿಸಿ',
  firstName: 'ಮೊದಲ ಹೆಸರು',
  lastName: 'ಕೊನೆಯ ಹೆಸರು',
  forgotPassword: 'ಪಾಸ್‌ವರ್ಡ್ ಮರೆತಿದ್ದೀರಾ?',
  alreadyHaveAccount: 'ಈಗಾಗಲೇ ಖಾತೆ ಇದೆಯೇ? ಸೈನ್ ಇನ್ ಮಾಡಿ',
  dontHaveAccount: 'ಖಾತೆ ಇಲ್ಲವೇ? ಸೈನ್ ಅಪ್ ಮಾಡಿ',
  
  // Posts & Content
  recent: 'ಇತ್ತೀಚಿನ',
  trending: 'ಟ್ರೆಂಡಿಂಗ್',
  popular: 'ಜನಪ್ರಿಯ',
  like: 'ಇಷ್ಟ',
  likes: 'ಇಷ್ಟಗಳು',
  comment: 'ಕಾಮೆಂಟ್',
  comments: 'ಕಾಮೆಂಟ್‌ಗಳು',
  share: 'ಹಂಚಿಕೊಳ್ಳಿ',
  delete: 'ಅಳಿಸಿ',
  edit: 'ಸಂಪಾದಿಸಿ',
  post: 'ಪೋಸ್ಟ್',
  posts: 'ಪೋಸ್ಟ್‌ಗಳು',
  title: 'ಶೀರ್ಷಿಕೆ',
  content: 'ವಿಷಯ',
  tags: 'ಟ್ಯಾಗ್‌ಗಳು',
  noBlogsFound: 'ಯಾವುದೇ ಬ್ಲಾಗ್‌ಗಳು ಕಂಡುಬಂದಿಲ್ಲ. ಬೇರೆ ಯಾವುದನ್ನಾದರೂ ಹುಡುಕಲು ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಮೊದಲನೆಯದನ್ನು ರಚಿಸಿ!',
  
  // AI Assistant
  quickActions: 'ತ್ವರಿತ ಕ್ರಿಯೆಗಳು',
  writeCaption: 'ಶೀರ್ಷಿಕೆ ಬರೆಯಿರಿ',
  suggestTopics: 'ವಿಷಯಗಳನ್ನು ಸೂಚಿಸಿ',
  improveContent: 'ವಿಷಯವನ್ನು ಸುಧಾರಿಸಿ',
  creativeIdeas: 'ಸೃಜನಾತ್ಮಕ ಆಲೋಚನೆಗಳು',
  clearChat: 'ಚಾಟ್ ತೆರವುಗೊಳಿಸಿ',
  aiWritingAssistant: 'AI ಬರವಣಿಗೆ ಸಹಾಯಕ',
  poweredByGroq: 'GROQ AI ನಿಂದ ಚಾಲಿತ',
  aiGreeting: 'ನಮಸ್ಕಾರ! ನಾನು ನಿಮ್ಮ AI ಬರವಣಿಗೆ ಸಹಾಯಕ. ನಾನು ನಿಮಗೆ ಆಕರ್ಷಕ ವಿಷಯವನ್ನು ರಚಿಸಲು, ಶೀರ್ಷಿಕೆಗಳನ್ನು ಬರೆಯಲು, ಪೋಸ್ಟ್ ವಿಷಯಗಳನ್ನು ಸೂಚಿಸಲು ಮತ್ತು ನಿಮ್ಮ ಬರವಣಿಗೆಯನ್ನು ಸುಧಾರಿಸಲು ಸಹಾಯ ಮಾಡಬಲ್ಲೆ. ಇಂದು ನೀವು ಯಾವುದರ ಮೇಲೆ ಕೆಲಸ ಮಾಡಲು ಬಯಸುತ್ತೀರಿ?',
  askMeToHelp: 'ವಿಷಯ, ಶೀರ್ಷಿಕೆಗಳು, ವಿಷಯಗಳು ಅಥವಾ ಬರವಣಿಗೆಯೊಂದಿಗೆ ಸಹಾಯಕ್ಕಾಗಿ ನನ್ನನ್ನು ಕೇಳಿ...',
  aiThinking: 'AI ಯೋಚಿಸುತ್ತಿದೆ...',
  
  // Chat & Messages
  chat: 'ಚಾಟ್',
  noConversationsYet: 'ಇನ್ನೂ ಸಂಭಾಷಣೆಗಳಿಲ್ಲ',
  ideafluxChat: 'IdeaFlux ಚಾಟ್',
  typeMessage: 'ಸಂದೇಶವನ್ನು ಟೈಪ್ ಮಾಡಿ...',
  sendMessage: 'ಸಂದೇಶ ಕಳುಹಿಸಿ',
  connectingToChat: 'ಚಾಟ್‌ಗೆ ಸಂಪರ್ಕಿಸುತ್ತಿದೆ...',
  
  // Notifications
  noNotificationsYet: 'ಇನ್ನೂ ಅಧಿಸೂಚನೆಗಳಿಲ್ಲ।',
  markAllRead: 'ಎಲ್ಲವನ್ನೂ ಓದಲಾಗಿದೆ ಎಂದು ಗುರುತಿಸಿ',
  clearAll: 'ಎಲ್ಲವನ್ನೂ ತೆರವುಗೊಳಿಸಿ',
  
  // Settings
  accountSettings: 'ಖಾತೆ ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
  displayName: 'ಪ್ರದರ್ಶನ ಹೆಸರು',
  emailAddress: 'ಇಮೇಲ್ ವಿಳಾಸ',
  languagePreference: 'ಭಾಷೆಯ ಆದ್ಯತೆ',
  privacySecurity: 'ಗೌಪ್ಯತೆ ಮತ್ತು ಭದ್ರತೆ',
  notificationPreferences: 'ಅಧಿಸೂಚನೆ ಆದ್ಯತೆಗಳು',
  allowDirectMessages: 'ನೇರ ಸಂದೇಶಗಳನ್ನು ಅನುಮತಿಸಿ',
  letOthersMessage: 'ಇತರ ಬಳಕೆದಾರರು ನಿಮಗೆ ಖಾಸಗಿ ಸಂದೇಶಗಳನ್ನು ಕಳುಹಿಸಲು ಅನುಮತಿಸಿ',
  likesOnPosts: 'ಪೋಸ್ಟ್‌ಗಳಲ್ಲಿ ಇಷ್ಟಗಳು',
  commentsOnPosts: 'ಪೋಸ್ಟ್‌ಗಳಲ್ಲಿ ಕಾಮೆಂಟ್‌ಗಳು',
  newFollowers: 'ಹೊಸ ಅನುಯಾಯಿಗಳು',
  mentions: 'ಉಲ್ಲೇಖಗಳು',
  save: 'ಉಳಿಸು',
  deleteAccount: 'ಖಾತೆಯನ್ನು ಅಳಿಸಿ',
  
  // Notification descriptions
  getNotifiedWhenSomeone: 'ಯಾರಾದರೂ ಇದ್ದಾಗ ಅಧಿಸೂಚನೆ ಪಡೆಯಿರಿ',
  likesYourPosts: 'ನಿಮ್ಮ ಪೋಸ್ಟ್‌ಗಳನ್ನು ಇಷ್ಟಪಡುತ್ತಾರೆ',
  commentsOnYourPosts: 'ನಿಮ್ಮ ಪೋಸ್ಟ್‌ಗಳಲ್ಲಿ ಕಾಮೆಂಟ್ ಮಾಡುತ್ತಾರೆ',
  followsYou: 'ನಿಮ್ಮನ್ನು ಅನುಸರಿಸುತ್ತಾರೆ',
  mentionsYou: 'ನಿಮ್ಮನ್ನು ಉಲ್ಲೇಖಿಸುತ್ತಾರೆ',
  chooseNotifications: 'ನೀವು ಯಾವ ಅಧಿಸೂಚನೆಗಳನ್ನು ಸ್ವೀಕರಿಸಲು ಬಯಸುತ್ತೀರಿ ಎಂಬುದನ್ನು ಆಯ್ಕೆಮಾಡಿ',
  controlWhoInteracts: 'ನಿಮ್ಮೊಂದಿಗೆ ಯಾರು ಸಂವಹನ ನಡೆಸಬಹುದು ಎಂಬುದನ್ನು ನಿಯಂತ್ರಿಸಿ',
  manageAccountInfo: 'ನಿಮ್ಮ ಖಾತೆ ಮಾಹಿತಿ ಮತ್ತು ಆದ್ಯತೆಗಳನ್ನು ನಿರ್ವಹಿಸಿ',
  emailCannotBeChanged: 'ಭದ್ರತಾ ಕಾರಣಗಳಿಗಾಗಿ ಇಮೇಲ್ ಬದಲಾಯಿಸಲಾಗುವುದಿಲ್ಲ',
  
  // Common
  loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
  cancel: 'ರದ್ದುಗೊಳಿಸಿ',
  update: 'ನವೀಕರಿಸಿ',
  submit: 'ಸಲ್ಲಿಸಿ',
  back: 'ಹಿಂದೆ',
  next: 'ಮುಂದೆ',
  previous: 'ಹಿಂದಿನ',
  online: 'ಆನ್‌ಲೈನ್',
  offline: 'ಆಫ್‌ಲೈನ್',
  
  // Profile
  editProfile: 'ಪ್ರೊಫೈಲ್ ಸಂಪಾದಿಸಿ',
  noBioYet: 'ಇನ್ನೂ ಬಯೋ ಇಲ್ಲ।',
  followers: 'ಅನುಯಾಯಿಗಳು',
  following: 'ಅನುಸರಿಸುತ್ತಿದೆ',
  recentActivity: 'ಇತ್ತೀಚಿನ ಚಟುವಟಿಕೆ',
  noPostsYet: 'ಇನ್ನೂ ಪೋಸ್ಟ್‌ಗಳಿಲ್ಲ',
  shareFirstPost: 'ನಿಮ್ಮ ಮೊದಲ ಪೋಸ್ಟ್ ಹಂಚಿಕೊಳ್ಳಿ!',
  bio: 'ಬಯೋ',
  dateOfBirth: 'ಜನ್ಮ ದಿನಾಂಕ',
  follow: 'ಅನುಸರಿಸಿ',
  unfollow: 'ಅನುಸರಿಸಬೇಡಿ',
  
  // Search
  discover: 'ಅನ್ವೇಷಿಸಿ',
  findPeopleStories: 'ನಿಮಗೆ ಮುಖ್ಯವಾದ ಜನರು, ಕಥೆಗಳು ಮತ್ತು ಆಲೋಚನೆಗಳನ್ನು ಹುಡುಕಿ',
  searchByName: 'ಹೆಸರು, ಶೀರ್ಷಿಕೆ ಅಥವಾ #ಟ್ಯಾಗ್ ಮೂಲಕ ಹುಡುಕಿ...',
  searchResults: 'ಹುಡುಕಾಟ ಫಲಿತಾಂಶಗಳು',
  noResultsFound: 'ಯಾವುದೇ ಫಲಿತಾಂಶಗಳು ಕಂಡುಬಂದಿಲ್ಲ',
  peopleFound: 'ಜನರು ಸಿಕ್ಕಿದ್ದಾರೆ',
  
  // Settings - Additional keys
  enterDisplayName: 'ನಿಮ್ಮ ಪ್ರದರ್ಶನ ಹೆಸರನ್ನು ನಮೂದಿಸಿ',
  saving: 'ಉಳಿಸುತ್ತಿದೆ...',
  confirmDeleteAccount: 'ನೀವು ನಿಮ್ಮ ಖಾತೆಯನ್ನು ಅಳಿಸಲು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ? ಇದನ್ನು ರದ್ದುಗೊಳಿಸಲಾಗುವುದಿಲ್ಲ.',
  accountDeletedSuccessfully: 'ಖಾತೆಯನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಅಳಿಸಲಾಗಿದೆ.',
  errorDeletingAccount: 'ಖಾತೆಯನ್ನು ಅಳಿಸುವಲ್ಲಿ ದೋಷ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  settingsSavedSuccessfully: 'ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಉಳಿಸಲಾಗಿದೆ!',
  failedToSaveSettings: 'ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಉಳಿಸುವಲ್ಲಿ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  
  // Form component
  pleaseSignInToCreate: 'ಪೋಸ್ಟ್ ರಚಿಸಲು ಸೈನ್ ಇನ್ ಮಾಡಿ।',
  titleRequired: 'ಪೋಸ್ಟ್ ಪ್ರಕಟಿಸಲು ಶೀರ್ಷಿಕೆ ಅಗತ್ಯ।',
  contentRequired: 'ಪೋಸ್ಟ್ ಪ್ರಕಟಿಸಲು ಕಥೆಯ ವಿಷಯ ಅಗತ್ಯ।',
  contentTooShort: 'ಕಥೆಯ ವಿಷಯವು ಕನಿಷ್ಠ 10 ಅಕ್ಷರಗಳ ಉದ್ದವಿರಬೇಕು.',
  postUpdatedSuccessfully: 'ಪೋಸ್ಟ್ ಯಶಸ್ವಿಯಾಗಿ ನವೀಕರಿಸಲಾಗಿದೆ!',
  postPublishedSuccessfully: 'ಪೋಸ್ಟ್ ಯಶಸ್ವಿಯಾಗಿ ಪ್ರಕಟಿಸಲಾಗಿದೆ!',
  pleaseSignInToCreateBlogs: 'ನಿಮ್ಮ ಸ್ವಂತ IdeaFlux ಬ್ಲಾಗ್‌ಗಳನ್ನು ರಚಿಸಲು ಸೈನ್ ಇನ್ ಮಾಡಿ.',
  enterEngagingTitle: 'ಆಕರ್ಷಕ ಶೀರ್ಷಿಕೆಯನ್ನು ನಮೂದಿಸಿ...',
  story: 'ಕಥೆ',
  writeYourMasterpiece: 'ನಿಮ್ಮ ಮಾಸ್ಟರ್‌ಪೀಸ್ ಬರೆಯಿರಿ...',
  addTags: 'ಟ್ಯಾಗ್‌ಗಳನ್ನು ಸೇರಿಸಿ...',
  add: 'ಸೇರಿಸಿ',
  publishPost: 'ಪೋಸ್ಟ್ ಪ್ರಕಟಿಸಿ',
  
  // Post component
  linkCopiedToClipboard: 'ಲಿಂಕ್ ಕ್ಲಿಪ್‌ಬೋರ್ಡ್‌ಗೆ ಕಾಪಿ ಮಾಡಲಾಗಿದೆ! ಹಂಚಿಕೆ ಎಣಿಕೆ ನವೀಕರಿಸಲಾಗಿದೆ.',
  youAndOthers: 'ನೀವು ಮತ್ತು {{count}} ಇತರರು',
  unknownUser: 'ಅಜ್ಞಾತ ಬಳಕೆದಾರ',
  noImage: 'ಚಿತ್ರವಿಲ್ಲ',
  deletePost: 'ಪೋಸ್ಟ್ ಅಳಿಸಿ',
  confirmDeletePost: 'ನೀವು ಈ ಪೋಸ್ಟ್ ಅನ್ನು ಅಳಿಸಲು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?',
};